export default __webpack_public_path__ + "static/media/triassic-park-door.408c9b8b.jpg";